import React from "react"

type IfChildren<E extends React.ElementType> = {
	as?: E
} & React.ComponentPropsWithoutRef<E>

const IfChildren = <E extends React.ElementType = "div">(
	props: IfChildren<E>
) => {
	const { as: Component = "div", children, ...otherProps } = props

	if (!children) return null

	return <Component {...otherProps}>{children}</Component>
}

export default IfChildren
